import React, { Component } from 'react';
import { HorizontalBar } from 'react-chartjs-2';
import loader from '../../src/components/css/dark/img/loader.gif';

class HorizontalBarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            chartData: [
            ],
            options: {

            },
            IsDataLoaded: false,
        }
    }
    componentDidUpdate(prevProp) {
        //if (prevProp.data.url != this.props.data.url && this.props.data.type == "Column") {
        //console.log("update bar", this.props)
        //  this.fetchData();
        //}
    }
    componentDidMount() {
        // if (this.props.data.type == "Column") {
        // console.log("mount bar", this.props)
        this.fetchData();
        //}
    }
    fetchData() {
        this.setState({
            ...this.state,
            IsDataLoaded: true,
            chartData: [
                {
                    datasets: [
                        {
                            //label: topLabel,
                            data: [this.props.data],
                            backgroundColor: '#ffba10',
                            borderColor: '#ffba10'
                        }
                    ]
                }
            ],
            options: {
                tooltips: {
                    enabled: false
                },
                scales: {
                    xAxes: [{
                        display: false,
                        gridLines: {},
                        ticks: {
                            beginAtZero: true,
                            max: this.props.maxValue,
                            fontColor: "#8ba6c1",
                            fontSize: 14
                        },
                    }],

                    yAxes: [{
                        display: false,
                        barThickness: 6,  // number (pixels) or 'flex'
                        gridLines: {},
                        position: 'right',
                        ticks: {
                            fontColor: "#8ba6c1",
                            fontSize: 14
                        }
                    }]
                },
                responsive: false,
                maintainAspectRatio: false,
                legend: false
            }
        });
        //});
    }
    render() {
        return (
            <td>
                {this.state.IsDataLoaded ? '' : (<div className="loader-section"><div className="theme-loader"></div></div>)}
                {
                    this.state.chartData.map((item, index) => {
                        // console.log(this.props)
                        return (
                            <HorizontalBar data={item} options={this.state.options} key={index} height={20} />
                        )
                    })
                }
            </td>
        )
    }
}
export default HorizontalBarChart;
